import { render } from "./AccountsBatchActions.vue?vue&type=template&id=1f66ad0c&scoped=true"
import script from "./AccountsBatchActions.vue?vue&type=script&lang=js"
export * from "./AccountsBatchActions.vue?vue&type=script&lang=js"

import "./AccountsBatchActions.vue?vue&type=style&index=0&id=1f66ad0c&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f66ad0c"]])

export default __exports__